"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ForecastChangeSupplierAgreementDTO_1 = require("./ForecastChangeSupplierAgreementDTO");

var ProductChangeType_1 = require("./ProductChangeType");
/**
 * Represents changes in window item. The name is not optimal but kept for legacy reasons.
 * It is used in snapshots and Approval report PM.
 * @author Adam Drda
 */


var ForecastChangeProductDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastChangeProductDTO, _DomainObject_1$Domai);

  function ForecastChangeProductDTO(productId, changeType, // WindowItem
  promoVolume, systemVolume, promoPrice, groupOfSitesId, // SupplierAgreement
  supplierAgreements, // Vendor Allowance
  vendorAllowance, // Window Changed
  windowChanged) {
    var _this;

    _classCallCheck(this, ForecastChangeProductDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeProductDTO).call(this));
    _this.productId = productId;
    _this.changeType = changeType;
    _this.promoVolume = promoVolume;
    _this.systemVolume = systemVolume;
    _this.promoPrice = promoPrice;
    _this.groupOfSitesId = groupOfSitesId;
    _this.supplierAgreements = supplierAgreements;
    _this.vendorAllowance = vendorAllowance;
    _this.windowChanged = windowChanged;
    return _this;
  }

  return ForecastChangeProductDTO;
}(DomainObject_1.DomainObject);

exports.ForecastChangeProductDTO = ForecastChangeProductDTO;

ForecastChangeProductDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastChangeProductDTO.name);
  return {
    productId: builder.str('productId'),
    changeType: builder.senum('changeType', ProductChangeType_1.ProductChangeType, CodebookLookupSequence_1.CodebookLookupSequence.ProductChangeType),
    promoVolume: builder.data('promoVolume', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    systemVolume: builder.data('systemVolume', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    promoPrice: builder.data('promoPrice', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    groupOfSitesId: builder.data('groupOfSitesId', {
      oldValue: builder.opt(builder.str('oldValue')),
      newValue: builder.opt(builder.str('newValue')),
      difference: builder.opt(builder.str('difference'))
    }),
    supplierAgreements: builder.listOf(builder.obj(ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO.name, ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO.schema, function (mat) {
      return ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO.fromDataDict(mat);
    })),
    vendorAllowance: builder.data('vendorAllowance', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    windowChanged: builder.data('windowChanged', {
      oldValue: builder.opt(builder.date('oldValue')),
      newValue: builder.opt(builder.date('newValue')),
      difference: builder.opt(builder.date('difference'))
    })
  };
}();